import { HasId } from '../../../../shared/basic-data-management/has-id.interface';

export class IntervenantTLR implements HasId {
	id!: number;
	oldId!: number;
	nom!: string;
	prenom!: string | null;
	indicatifTelephone!: string | null;
	telephone!: string | null;
	entrepriseId!: number | null;
	email!: string | null;
	idGmao!: string | null;
	cadreEmploi!: string | null;
	interne!: boolean | null;
	travailleurDetache!: boolean | null;
	obsolete!: boolean;
	dateCreation!: number[] | null;
	dateModification!: number[] | null;
	estResponsable!: boolean | null;
	
	constructor() {}
}